import { Button, Dropdown } from "react-bootstrap";
import "./styles.scss";

function LanguageButtonWithDialect({ currentLanguage, targetLanguage, onLangSelect }) {
    return (
        <Dropdown
            drop="end"
        >
            <Dropdown.Toggle
                variant={currentLanguage.uid === targetLanguage?.uid ? "primary" : "outline-dark"}
                className="rounded-5 me-2 mt-3 dialect-select-dropdown-toggle"
            >
                {currentLanguage.langText} ❯ 
            </Dropdown.Toggle>
            <Dropdown.Menu className="dialect-select-dropdown rounded-4 shadow-lg border-0">
                <div>
                {
                    currentLanguage.dialects.map(d => (
                        <Dropdown.Item
                            key={d.dialectCode}
                            onClick={() => onLangSelect?.(currentLanguage, d)}
                        >
                            {d.dialectName}
                        </Dropdown.Item>
                    ))
                }
                </div>
            </Dropdown.Menu>
        </Dropdown>
    );
}

function LanguageButton({ currentLanguage, targetLanguage, onLangSelect }) {
    return (
        <Button
            variant={currentLanguage.uid === targetLanguage?.uid ? "primary" : "outline-dark"}
            className="rounded-5 me-2 mt-3 dialect-select-dropdown-toggle"
            onClick={() => onLangSelect?.(currentLanguage, currentLanguage.dialects[0])}
        >
            {currentLanguage.langText}
        </Button>
    );
}

function LanguageList({ show, langList, targetLanguage, onLangSelect }) {
    return (
        <div className={`sliding-div-container ${show ? 'show' : ''}`}>
            <div className="d-flex flex-wrap justify-content-center">
                {
                    langList.filter(x => !x.hidden).map(x => 
                        x.dialects.length > 1
                            ? <LanguageButtonWithDialect key={x.uid} currentLanguage={x} targetLanguage={targetLanguage} onLangSelect={onLangSelect} />
                            : <LanguageButton key={x.uid} currentLanguage={x} targetLanguage={targetLanguage} onLangSelect={onLangSelect} />
                    )
                }
            </div>
        </div>
    )
}

export default LanguageList;
